import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import IntersectionObserver from '@researchgate/react-intersection-observer';
import classNames from 'clsx';

import styles from 'src/components/EmptyListing/EmptyListing.scss';


const EmptyListing = function ({
  image, imageType, header, footer
}) {
  const [shouldRenderImage, setShouldRenderImage] = useState(false);

  const observerCallback = useCallback(
    ({ isIntersecting }, unobserve) => requestIdleCallback(() => {
      if (isIntersecting) {
        setShouldRenderImage(true);
        unobserve();
      }
    }),
    []
  );

  return (
    <div styleName="empty-listing">
      <IntersectionObserver onChange={ observerCallback } rootMargin="100px">
        <div
          className={ classNames(styles['empty-listing__bitmap'], {
            [styles['empty-listing__bitmap__wide']]: imageType === 'wide',
            [styles['empty-listing__bitmap__normal']]: imageType === 'normal'
          }) }
        >
          {shouldRenderImage ? image : ''}
        </div>
      </IntersectionObserver>

      <div styleName="empty-listing__actions">
        <h3 styleName="empty-listing__header">{header}</h3>

        {footer}
      </div>
    </div>
  );
};

EmptyListing.defaultProps = {
  imageType: 'normal'
};

EmptyListing.propTypes = {
  footer: PropTypes.node.isRequired,
  header: PropTypes.string.isRequired,
  image: PropTypes.node.isRequired,
  imageType: PropTypes.oneOf(['normal', 'wide'])
};

export default EmptyListing;
